module.exports = __webpack_public_path__ + "static/media/GoalSetting.aa651198.mp3";